import { useMutation } from '@apollo/client';

import {
  BulkUpdateProRataEndDate,
  BulkUpdateProRataEndDateVariables
} from '@/graphql/contracts/_generated_/bulkUpdateProRataEndDate.mutation';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import GetBCContractLinesQuery from '@/graphql/contracts/getPaginatedFilteredBCContractLines.query.gql';
import BulkUpdateProRataEndDateMutation from '@/graphql/contracts/bulkUpdateProRataEndDate.mutation.gql';
import { notificationService } from '@/services/notification/notification.client';
import { ALL_ITEMS } from '@/config/common.config';

export function useBulkUpdateProRataEndDate(contractId: UUID) {

  const [_bulkUpdateProRataEndDate, { loading }] = 
  useMutation<BulkUpdateProRataEndDate, BulkUpdateProRataEndDateVariables>(
    BulkUpdateProRataEndDateMutation,
    {
      client: apolloClientContracts,
      onCompleted(data) {
        if ((data?.bulkUpdateProRataEndDate?.errors?.length ?? 0) > 0) {
          data?.bulkUpdateProRataEndDate?.errors?.forEach(error => {
            notificationService.open({
              title: 'Error',
              text: error.message,
              type: 'danger'
            });
          });
        }
      },
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      awaitRefetchQueries: true,
    },
  );

  const bulkUpdateProRataEndDate = async (params: BulkUpdateProRataEndDateVariables) => {
    const refetchQueries = [
      {
        query: GetBCContractLinesQuery,
        variables: {
          filter: {
            contractId: { eq: contractId }
          },
          first: ALL_ITEMS
        }
      }
    ];
    
    const result = await _bulkUpdateProRataEndDate({
      variables: {
        ...params,
      },
      awaitRefetchQueries: true,
      refetchQueries: refetchQueries
    });

    return result?.data?.bulkUpdateProRataEndDate;
  };

  return {
    bulkUpdateProRataEndDate,
    bulkUpdateProRataEndDateLoading: loading
  };
}
